import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ITipoIdentificacion } from '../shared/interfaces/seguridad';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class TipoIdentificacionService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/tipo-identificacion`;
  }

  getTipoIdentificaciones(): Observable<ITipoIdentificacion[]> {
    return this.http.get<ITipoIdentificacion[]>(`${this.baseUrl}/public`);
  }

  getTipoIdentificacionesOrdinales(): Observable<ITipoIdentificacion[]> {
    return this.http.get<ITipoIdentificacion[]>(`${this.baseUrl}/public/ordinales`);
  }
}
